import { PermissionsEnum } from "@/auth/interfaces";
import {
  ROUTER_PATHS, handleErrorForm, hasPermission, gridSizeMdLg12, SegmentacionENUM, texto,
  gridSizeMdLg6, TIPO_IDENTIFICACIONES_CHOICE, TipoIdentificacionEnumChoice,
  gridSizeConst10, gridSizeConst2,
  // EstadoProspectoEnum,
  // formatDateWithTimeAMPM,
} from "@/shared";
import {
  SingleTableBoxScene, TabTextLabel, CustomAutocompleteArrString, CustomTextFieldNumberComponente,
  CustomTextField,
  CustomTextArea,
  // CustomTextFieldNoForm,
} from "@/shared/components/ui";
import { CustomAlertCard } from "@/shared/components/ui/Alerts";
import { TiposTextFieldNumberEnum } from "@/shared/components/ui/CustomTextFieldNumberComponente";
import { ErrorMessagesForm, IProspectoCorporativo, TipoDocumentoNameEnum } from "@/shared/interfaces";
import { Grid, Typography, IconButton, FormControlLabel, Checkbox } from "@mui/material";
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import SearchIcon from '@mui/icons-material/Search';
import { useProspectoCorporativo } from "../../hooks/useProspectoCorporativo";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import CondicionVentaSelector from "../CondicionVentaSelector";
import HistorialActualizacionesProspecto from "./HistorialActualizacionesProspecto";
import { useEffect } from "react";
import { toast } from "react-toastify";
// import { useUiConfirmModalStore } from "@/store/ui";

const ESTADO_CONTRIBUYENTE_RUC = ['ACTIVO', 'SUSPENDIDO']
const TIPO_CONTRIBUYENTE_RUC = ['SOCIEDAD', 'PERSONA NATURAL']
const REGIMEN_RUC = ['RIMPE', 'GENERAL']

interface SaveProspectoProps {
  title: string;
  enableEdit?: boolean;
  prospecto_corporativo?: IProspectoCorporativo
}

export default function SaveProspectoCorporativo({
  title,
  enableEdit = false,
  prospecto_corporativo,
}: SaveProspectoProps) {

  // const setConfirmDialog = useUiConfirmModalStore((s) => s.setConfirmDialog);
  // const setConfirmDialogIsOpen = useUiConfirmModalStore(
  //   (s) => s.setConfirmDialogIsOpen
  // );

  const {
    setEsDifunto,
    setEsCliente,
    setDisableIdentification,
    // disableIdentification,
    setIsGlobalLoading,
    setEsResidente,
    setcheckedResidencia,
    esResidente,
    checkedResidencia,
    form,
    control,
    reset,
    errors,
    setError,
    setModalProspectoEnProceso,
    setDataProspectoEnProceso,
    modalProspectoEnProceso,
    // dataProspectoEnProceso,
    //fn
    onSubmit,
    fnBuscarIdentificacion,
    // handleCrearSolicitudNuevaLinea,
    // handleBuscarSolicitudCanje,
    // handleBuscarIconSolicitudCanje,
    // handleLimpiarSolicitudCanjeEvento,
    ///* solicitud canje
    // dataCanje,
    // dataEvento,
    //isLoadingSolicitudCanje
    handleOnSubmitUpdate,
    valorRestriccionCel
  } = useProspectoCorporativo(prospecto_corporativo);
  const watcherCondicionVenta = form.watch().condicion_venta

  useEffect(() => {

    !!watcherCondicionVenta ?
      reset({
        ...form.getValues(),
        requiere_cotizacion: true
      })
      :
      reset({
        ...form.getValues(),
        requiere_cotizacion: false
      })

    //console.log(form.getValues())
  }, [watcherCondicionVenta]);



  return (
    <>
      <SingleTableBoxScene
        py={4}
        title={title}
        iconRedirect={<FormatListBulletedIcon />}
        enableRedirect={true}
        textRedirect='Prospectos'
        textCreateOrEditBtn='Guardar'
        urlRedirect={ROUTER_PATHS.ventasCorporativas.prospectoCorporativoNav}
        visibleReport={false}
        fnCreateOrEdit={form.handleSubmit(onSubmit, (error) => {
          handleErrorForm(error as ErrorMessagesForm);
        })}
        enableCreateOrEditBtn={hasPermission(PermissionsEnum.api_add_prospectocorporativo)}
      >

        <Grid container spacing={3}>


          {
            form.getValues().segmentacion === SegmentacionENUM.NO_DATA && (
              <CustomAlertCard
                alertColor='info'
                alertTitle="Nota"
                alertMessage={texto.no_informacion_equifax} />
            )
          }


          <Grid item   {...gridSizeMdLg6}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <TabTextLabel text={texto.informacion_corporativo} mt={0} pb={2} pl={0} pt={0} />
              </Grid>
              <CustomAutocompleteArrString
                disabled={enableEdit}
                size={gridSizeMdLg6}
                label={texto.tipo_documento}
                name="tipo_identificacion"
                options={TIPO_IDENTIFICACIONES_CHOICE.filter(e => e == TipoIdentificacionEnumChoice.RUC) || []}
                defaultValue={form.getValues().tipo_identificacion}
                isLoadingData={false}
                control={control}
                error={errors.tipo_identificacion}
                helperText={errors.tipo_identificacion?.message}
                onChangeValue={(e) => {

                  reset({ tipo_identificacion: e });
                  setEsCliente({ alerta: false, linea: undefined, nombre: '', plan: '' });
                  if (e == TipoDocumentoNameEnum.CEDULA || e == TipoDocumentoNameEnum.RUC) {
                    reset({ tipo_identificacion: form.getValues().tipo_identificacion });
                    setDisableIdentification(false);
                    return;
                  }
                  setDisableIdentification(true);

                }}
              />

              <Grid item container {...gridSizeMdLg6} spacing={1} alignItems={'center'}>
                <CustomTextFieldNumberComponente
                  // disabled={disableIdentification}
                  disabled={enableEdit}
                  size={gridSizeConst10}
                  max={form.getValues().tipo_identificacion == TipoDocumentoNameEnum.CEDULA ? 10 : 13}
                  type={TiposTextFieldNumberEnum.IDENTIFICACION}
                  label={texto.identificacion}
                  error={errors.identificacion}
                  helperText={errors.identificacion?.message}
                  control={control}
                  name="identificacion"
                  defaultValue={form.getValues().identificacion || ''}

                  onChangeValue={aux => {
                    setEsDifunto(false);
                    setEsCliente({ alerta: false, linea: undefined, nombre: '', plan: '' })
                    if (aux) {
                      switch (form.getValues().tipo_identificacion) {
                        // case TipoDocumentoNameEnum.CEDULA:
                        //   if (aux?.length == 10) {
                        //     reset({ tipo_identificacion: form.getValues().tipo_identificacion, identificacion: aux });
                        //     setIsGlobalLoading(true);
                        //     fnBuscarIdentificacion(aux);
                        //     return;
                        //   }
                        //   reset({ tipo_identificacion: form.getValues().tipo_identificacion, identificacion: aux });
                        //   setEsCliente({ alerta: false, linea: undefined, nombre: '', plan: '' });
                        //   break;

                        case TipoDocumentoNameEnum.RUC:
                          if (aux?.length > 12) {
                            reset({ ...form.getValues(), identificacion: aux });
                            setIsGlobalLoading(true);
                            fnBuscarIdentificacion(aux);
                            return;
                          }
                          reset({ tipo_identificacion: form.getValues().tipo_identificacion, identificacion: aux });
                          setEsCliente({ alerta: false, linea: undefined, nombre: '', plan: '' });
                          break;
                        default:
                          reset({ tipo_identificacion: form.getValues().tipo_identificacion })
                          setEsResidente(false);
                          setcheckedResidencia(true);
                          break;
                      }
                      return;
                    }
                    reset({ tipo_identificacion: form.getValues().tipo_identificacion, identificacion: '' })

                  }}
                />
                {
                  !enableEdit?
                    <Grid item {...gridSizeConst2}>
                      <IconButton onClick={(e: any) => {
                        e.preventDefault();
                        if(form.getValues().tipo_identificacion !== TipoDocumentoNameEnum.RUC ){
                          return toast.error('Escoja el tipo de identificación');
                        }
                        if(form.getValues().identificacion?.length !== 13){
                          return toast.error('El RUC debe tener 13 dígitos');
                        }
                        if (form.getValues().identificacion){
                          reset({ tipo_identificacion: form.getValues().tipo_identificacion, identificacion: form.getValues().identificacion });
                          setEsCliente({ alerta: false, linea: undefined, nombre: '', plan: '' });
                          setIsGlobalLoading(true);
                          fnBuscarIdentificacion(form.getValues().identificacion || '')
                        }else{
                          setError('identificacion', { message: 'Campo obligatorio' })
                        }


                      }} size="small">
                        <SearchIcon />
                      </IconButton>
                    </Grid>
                  :null
                }
              </Grid>


              <CustomTextField
                disabled={enableEdit}
                control={control}
                name="razon_social"
                type="texto_sin_numeros"
                defaultValue={form.getValues().razon_social}
                size={gridSizeMdLg12}
                label={'Razón Social'}
                error={errors.razon_social}
                helperText={errors.razon_social?.message}
                />


              <CustomAutocompleteArrString
                disabled={enableEdit}
                label="Tipo contribuyente"
                name="tipo_contribuyente"
                options={TIPO_CONTRIBUYENTE_RUC}
                control={form.control}
                defaultValue={form.getValues().tipo_contribuyente || ''}
                error={errors.tipo_contribuyente}
                helperText={errors.tipo_contribuyente?.message?.toString() ?? ''}
                isLoadingData={false}
                size={gridSizeMdLg12}
              />

              <CustomAutocompleteArrString
                disabled={enableEdit}
                label="Estado Contribuyente"
                name="estado_contribuyente_ruc"
                options={ESTADO_CONTRIBUYENTE_RUC}
                control={form.control}
                defaultValue={form.getValues().estado_contribuyente_ruc || ''}
                error={errors.estado_contribuyente_ruc}
                helperText={errors.estado_contribuyente_ruc?.message?.toString() ?? ''}
                isLoadingData={false}
                size={gridSizeMdLg6}
              />

              <CustomAutocompleteArrString
                disabled={enableEdit}
                label="Régimen"
                name="regimen"
                options={REGIMEN_RUC}
                control={form.control}
                defaultValue={form.getValues().regimen || ''}
                error={errors.regimen}
                helperText={errors.regimen?.message?.toString() ?? ''}
                isLoadingData={false}
                size={gridSizeMdLg6}
              />

              <CustomTextField
                disabled={enableEdit}
                control={control}
                name="actividad_economica_principal"
                type="texto_sin_numeros"
                defaultValue={form.getValues().actividad_economica_principal}
                size={gridSizeMdLg12}
                label={'Actividad Económica Principal'}
                error={errors.actividad_economica_principal}
                helperText={errors.actividad_economica_principal?.message} />

              {esResidente && (
                <Grid item {...gridSizeMdLg6}>
                  <FormControlLabel control={
                    <Checkbox
                      disabled={enableEdit}
                      name="residencia_permanente"
                      defaultChecked={checkedResidencia}
                      checked={checkedResidencia}
                      onChange={event => setcheckedResidencia(event.target.checked)}
                    />}
                    label={<Typography variant="body2">
                      Residencia Permanente
                    </Typography>} />
                </Grid>
              )
              }




            </Grid>

          </Grid>

          <Grid item {...gridSizeMdLg6}>
            <Grid container spacing={3}>
              {
                enableEdit && (
                  <Grid item xs={12}>
                    <HistorialActualizacionesProspecto 
                    handleOnSubmit={(textWritten)=>handleOnSubmitUpdate(textWritten)}
                    historyProspectoCorporativo={form?.getValues().historial_actualizaciones || []}/>
                  </Grid>
                )
              }
              <Grid item xs={12}>
                <TabTextLabel text={"Datos Adicionales"} mt={0} pb={2} pl={0} pt={0} />
              </Grid>


              {/* <CustomTextField
                disabled={true}
                control={control}
                name="puntaje_score"
                defaultValue={form.getValues().puntaje_score || ''}
                size={gridSizeMdLg12}
                label={texto.puntaje_score}
                error={errors.puntaje_score}
                helperText={errors.puntaje_score?.message} />

              <CustomTextField
                disabled={true}
                control={control}
                name="puntaje_score_sobreendeudamiento"
                defaultValue={form.getValues().puntaje_score_sobreendeudamiento || ''}
                size={gridSizeMdLg12}
                label={texto.puntaje_score_sobreendeudamiento}
                error={errors.puntaje_score_sobreendeudamiento}
                helperText={errors.puntaje_score_sobreendeudamiento?.message} />

              <CustomTextField
                disabled={true}
                control={control}
                name="puntaje_score_empresa"
                defaultValue={form.getValues().puntaje_score_empresa || ''}
                size={gridSizeMdLg12}
                label={texto.puntaje_score_empresa}
                error={errors.puntaje_score_empresa}
                helperText={errors.puntaje_score_empresa?.message} />

              <CustomTextField
                disabled={true}
                control={control}
                name="segmentacion"
                defaultValue={form.getValues().segmentacion || ''}
                size={gridSizeMdLg12}

                label={texto.segmentacion}
                error={errors.segmentacion}
                helperText={errors.segmentacion?.message} /> */}

              


              <CustomTextField
                disabled={enableEdit}
                control={control}
                type="email"
                name="email"
                defaultValue={form.getValues().email || ''}
                size={gridSizeMdLg12}
                label={texto.email}
                error={errors.email}
                helperText={errors.email?.message} />
              <CustomTextField
                disabled={enableEdit}
                control={control}
                name="persona_contacto"
                defaultValue={form.getValues().persona_contacto || ''}
                size={gridSizeMdLg12}
                label={"Persona de Contacto"}
                error={errors.persona_contacto}
                helperText={errors.persona_contacto?.message} />
              <CustomTextField
                disabled={enableEdit}
                control={control}
                name="direccion"
                defaultValue={form.getValues().direccion || ''}
                size={gridSizeMdLg12}
                label={texto.direccion}
                error={errors.direccion}
                helperText={errors.direccion?.message} />

              <CustomTextFieldNumberComponente
                disabled={enableEdit}
                size={gridSizeMdLg12}
                type={TiposTextFieldNumberEnum.CELULAR}
                label={texto.celular}
                error={errors.celular}
                helperText={errors.celular?.message}
                control={control}
                name="celular"
                defaultValue={form.getValues().celular || ''}
                customRestriccionCelular={valorRestriccionCel}
              />
              <CustomTextFieldNumberComponente
                disabled={enableEdit}
                size={gridSizeMdLg12}
                type={TiposTextFieldNumberEnum.TELEFONO}
                label={texto.telefono}
                error={errors.telefono}
                helperText={errors.telefono?.message}
                control={control}
                name="telefono"
                required={false}
                defaultValue={form.getValues().telefono || ''}
                customRestriccionCelular={valorRestriccionCel}
                max={9}
              />
            </Grid>
          </Grid>
          <Grid container item spacing={2} {...gridSizeMdLg12} >
              <CustomTextArea
                disabled={enableEdit}
                size={gridSizeMdLg12}
                label={"Observación Vendedor"}
                error={errors.observacion_vendedor}
                helperText={errors.observacion_vendedor?.message}
                control={control}
                name="observacion_vendedor"
                defaultValue={form.getValues().observacion_vendedor || ''}
                autoGrow
                maxRows={14}
              />
          </Grid>
          
          <CondicionVentaSelector form={form}/>


        </Grid>

      </SingleTableBoxScene>

      {/* Modal para solicitar nueva linea */}
      {/* 
      // =============================================================================
      // Queda en desuso por nuevos requerimientos
      // =============================================================================
      */}
      {/* {
        modalProspectoEnProceso && (
          <ScrollableDialogProps
            onCloseIcon={() => setModalProspectoEnProceso(false)}
            open={modalProspectoEnProceso}
            title="Solicitar nueva línea"
            dialogContentText={`El cliente con identificación "${dataProspectoEnProceso?.identificacion!}" tiene un servicio en proceso.
              ¿Te gustaría solicitar una nueva línea al supervisor?`}
            showConfirmBtn={true}
            onConfirm={async () => {
              handleCrearSolicitudNuevaLinea()
            }}
            confirmVariantBtn={'contained'}
            onClose={() => {
              setModalProspectoEnProceso(false)
              setDataProspectoEnProceso(null)
            }}
            contentNode={

              <Grid container spacing={3}>

                <CustomTextFieldNoForm
                  disabled={true}
                  label={'Fecha de registro'}
                  defaultValue={formatDateWithTimeAMPM(dataProspectoEnProceso?.fecha_creacion!)}
                  size={gridSizeMdLg6}
                />

                <CustomTextFieldNoForm
                  disabled={true}
                  label={'Canal de venta'}
                  defaultValue={dataProspectoEnProceso?.canal_venta_create}
                  size={gridSizeMdLg6}
                />

                <CustomTextFieldNoForm
                  disabled={true}
                  label={'Estado'}
                  defaultValue={EstadoProspectoEnum.EN_PROCESO}
                  size={gridSizeMdLg6}
                />

                <CustomTextFieldNoForm
                  disabled={true}
                  label={'Vendedor'}
                  defaultValue={dataProspectoEnProceso?.user_create}
                  size={gridSizeMdLg6}
                />

                <Grid item xs={12}>
                  <Alert severity="success">{`El cliente tiene una venta EN PROCESO`}</Alert>
                </Grid>

              </Grid>
            }
          />
        )
      } */}

      {/* No permitir nuevas lineas */}
      {
        modalProspectoEnProceso && (
          <ScrollableDialogProps
            onCloseIcon={() => setModalProspectoEnProceso(false)}
            open={modalProspectoEnProceso}
            title="Prospecto Previamente Creado"
            showConfirmBtn={false}
            cancelTextBtn="Cerrar"
            confirmVariantBtn={'contained'}
            onClose={() => {
              setModalProspectoEnProceso(false)
              setDataProspectoEnProceso(null)
            }}
            contentText={
              "El cliente ya cuenta con un PROSPECTO previo. Proceda a crearlo desde la ventana de PREVENTAS."
            }
          />
        )
      }
    </>
  );

}